const getPasswordStrength = (val) => {
  let strength = 1;
  const strengths = {
    1: { color: '#707c80', msg: 'Too Short' },
    2: { color: '#dc2a2a', msg: 'Weak' },
    3: { color: '#fcc300', msg: 'Almost There' },
    4: { color: '#73b93b', msg: 'Strong' },
  };

  if (val == null) {
    return {
      strength,
      color: strengths[strength].color,
      message: strengths[strength].msg,
    };
  }

  // If the password length is less than 8
  // strength is 1
  if (val.length <= 7) strength = 1;

  // If the password length is greater than 6 and contain any
  // lowercase alphabet or any number or any special character
  // strength is 2
  if (val.length > 7 && (val.match(/[a-z]/) || val.match(/\d+/)
    || val.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,),+,=,<,>]/))) strength = 2;

  // If the password length is greater than 6 and contain alphabet,
  // number,special character respectively
  // strength is 3
  if (val.length > 7 && ((val.match(/[a-z]/) && val.match(/\d+/))
    || (val.match(/\d+/) && val.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,),+,=,<,>]/))
    || (val.match(/[a-z]/) && val.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,),+,=,<,>]/)))) strength = 3;

  // If the password length is greater than 6 and must contain uppsercase and lowercase alphabets,
  // numbers and special characters
  // strength is 4
  if (val.length > 7 && val.match(/[a-z]/) && val.match(/[A-Z]/)
    && val.match(/\d+/) && val.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,),+,=,<,>]/)) strength = 4;

  return {
    strength,
    color: strengths[strength].color,
    message: strengths[strength].msg,
  };
};

export default getPasswordStrength;
